const TrainingHelper = {
  parseTrainingData(taskData: string): string {
    const statusMap = {
      false: this.$t('no'),
      true: this.$t('yes'),
      pre_work: this.$t('pre-work'),
      post_work: this.$t('post-work'),
      training: this.$t('training'),
      new: this.$t('new'),
      completed: this.$t('completed'),
      missed: this.$t('missed'),
      rejected: this.$t('rejected'),
      accepted: this.$t('completed'),
      results_uploaded: this.$t('submitted'),
      in_progress: this.$t('inProgress'),
      cancelled: this.$t('cancelled'),
    };
    return statusMap[taskData] !== undefined ? statusMap[taskData] : taskData;
  },
  parseCategoryData(categoryData: string): string {
    const statusMap = {
      training_materials: this.$t('trainingMaterials'),
      after_f2f: this.$t('afterF2f'),
      before_vc: this.$t('beforeVc'),
      after_vc: this.$t('afterVc'),
      before_f2f: this.$t('beforeF2f'),
      other: this.$t('other'),
    };
    return statusMap[categoryData] !== undefined ? statusMap[categoryData] : categoryData;
  },
  getMeetingType(meetingType: string): string {
    const meetingTypeMap = {
      on_location: this.$t('onLocation'),
      online: this.$t('online'),
      digital: this.$t('digital'),
    };
    return meetingTypeMap[meetingType] !== undefined ? meetingTypeMap[meetingType] : meetingType;
  },
  getStatusIconClass(status: string): Record<string, any> {
    return {
      'el-icon-success': status === 'accepted',
      'el-icon-success blue': status === 'results_uploaded' || status === 'results_uploaded',
      'el-icon-warning': status === 'rejected' || status === 'missed',
    };
  },
  processTrainingSessionsFromObject(training: Record<string, any>): Record<string, any> {
    const sessionsForCalendar = [];

    if (training) {
      const modules = training.training_modules || [];

      modules.forEach((module) => {
        const sessions = module.training_sessions || [];

        sessions.forEach((session) => {
          const sessionDate = session?.date?.date ? new Date(session?.date?.date) : null;
          const sessionDeadline = session.deadline ? new Date(session.deadline) : null;

          const sessionDateTime = sessionDate || sessionDeadline;

          if (sessionDateTime) {
            const sessionObject = {
              deadline: sessionDateTime,
              status: session.status,
              name: session.name,
              id: session.id,
              type: 'session',
              trainingId: training.id,
            };
            sessionsForCalendar.push(sessionObject);
          }
        });
      });
    }
    return sessionsForCalendar;
  },

  processTasksFromObject(
    training: Record<string, any>,
    trainingCandidateId: string,
  ): Record<string, any> {
    const tasksForCalendar = [];

    if (training) {
      const modules = training.training_modules || [];

      modules.forEach((module) => {
        const sessions = module.training_sessions || [];

        sessions.forEach((session) => {
          const candidateSessions = session.candidate_training_sessions || [];
          const sessionDate = session?.date?.date ? new Date(session?.date?.date) : null;
          const sessionDeadline = session.deadline ? new Date(session.deadline) : null;

          const sessionDateTime = sessionDate || sessionDeadline;

          candidateSessions
            .filter((candidateSession) => candidateSession.candidate.id === trainingCandidateId)
            .forEach((candidateSession) => {
              const task = {
                deadline: sessionDateTime,
                status: candidateSession.status,
                name: candidateSession.stage,
                id: candidateSession.id,
                type: 'task',
                trainingId: training.id,
              };
              tasksForCalendar.push(task);
            });
        });
      });
    }
    return tasksForCalendar;
  },
  processTrainingSessionsFromArray(trainings: Record<string, any>): Record<string, any> {
    const sessionsForCalendar = [];

    if (trainings) {
      trainings.forEach((session) => {
        const sessionDate = session?.date?.date ? new Date(session?.date?.date) : null;
        const sessionDeadline = session.deadline ? new Date(session.deadline) : null;

        const sessionDateTime = sessionDate || sessionDeadline;

        if (sessionDateTime) {
          const sessionObject = {
            deadline: sessionDateTime,
            status: session.status,
            name: session.name,
            id: session.id,
            type: 'session',
            trainingId: session.training_module.training.id,
          };
          sessionsForCalendar.push(sessionObject);
        }
      });
    }
    return sessionsForCalendar;
  },

  processClientTrainingSessionsFromObject(
    training: Record<string, any>,
    activeTrainingId: string,
  ): any[] {
    const sessionsForCalendar = [];

    if (training) {
      const modules = training.training_modules || [];

      modules.forEach((module) => {
        const sessions = module.training_sessions || [];

        sessions.forEach((session) => {
          const sessionDate = session?.date?.date ? new Date(session?.date?.date) : null;
          const sessionDeadline = session.deadline ? new Date(session.deadline) : null;

          const sessionDateTime = sessionDate || sessionDeadline;

          if (sessionDateTime) {
            const sessionObject = {
              deadline: sessionDateTime,
              status: session.status,
              name: session.name,
              id: session.id,
              type: 'session',
              trainingId: activeTrainingId,
            };
            sessionsForCalendar.push(sessionObject);
          }
        });
      });
    }
    return sessionsForCalendar;
  },

  processClientTrainingSessionsFromArray(trainings: Record<string, any>): any[] {
    const sessionsForCalendar = [];

    if (trainings) {
      trainings.forEach((session) => {
        const sessionDate = session?.date?.date ? new Date(session?.date?.date) : null;
        const sessionDeadline = session.deadline ? new Date(session.deadline) : null;

        const sessionDateTime = sessionDate || sessionDeadline;

        if (sessionDateTime) {
          const sessionObject = {
            deadline: sessionDateTime,
            status: session.status,
            name: session.name,
            id: session.id,
            type: 'session',
            trainingId: session.training_module.training.id,
          };
          sessionsForCalendar.push(sessionObject);
        }
      });
    }
    return sessionsForCalendar;
  },

  processTasksFromArray(trainings: Record<string, any>): Record<string, any> {
    const tasksForCalendar = [];

    if (trainings) {
      trainings.forEach((session) => {
        const candidateSessions = session.candidate_training_sessions || [];
        const sessionDate = session?.date?.date ? new Date(session?.date?.date) : null;
        const sessionDeadline = session.deadline ? new Date(session.deadline) : null;

        const sessionDateTime = sessionDate || sessionDeadline;

        candidateSessions.forEach((candidateSession) => {
          const task = {
            deadline: sessionDateTime,
            status: candidateSession.status,
            name: candidateSession.stage,
            id: candidateSession.id,
            type: 'task',
            trainingId: session.training_module.training.id,
          };
          tasksForCalendar.push(task);
        });
      });
    }

    return tasksForCalendar;
  },
  categorizeFiles(sourceFiles: Record<string, any>[], self): Record<string, any>[] {
    const categoriesWithFiles = [];

    sourceFiles.forEach((file) => {
      const category = file.category || self.$t('other');
      const existingCategory = categoriesWithFiles.find(
        (categoryWithFiles) => categoryWithFiles.category === category,
      );

      if (existingCategory) {
        existingCategory.files.push(file);
      } else {
        categoriesWithFiles.push({
          category: category,
          files: [file],
        });
      }
    });

    return categoriesWithFiles;
  },
};
export default TrainingHelper;
